import React from "react";

import { useDispatch, useSelector } from "react-redux";

import { openDispatchingModal } from "actions";

import { Column, Row } from "components/Layout";
import { Paper } from "components/Paper";

import AgGridContainer from "components/AgGrid/AgGridContainer";

import { AgGridTables } from "constants/aggrid";
import { ModalTypes } from "constants/navigation";

import { getReturnTo } from "lib/navigation";

import { selectBusinessLabelsAggridData } from "selectors/businessLabel";
import { useCanAddBusinessLabelPermission } from "hooks";
import { BusinessLabelColumnDef } from "constants/columnDefinitions/businessLabel";

export const columnDefs = Object.values(BusinessLabelColumnDef);

export const BusinessLabelTable = () => {
  const dispatch = useDispatch();
  const rowData = useSelector(selectBusinessLabelsAggridData);

  const hasCanAddBusinessLabelPermission = useCanAddBusinessLabelPermission();

  const openCreateBusinessLabel = () =>
    dispatch(openDispatchingModal(ModalTypes.BusinessLabel, getReturnTo(), {}));

  const additionalActions = [
    {
      title: "Create Business Label",
      dataTour: "createBusinessLabel",
      onClick: openCreateBusinessLabel,
      isDisabled: !hasCanAddBusinessLabelPermission,
    },
  ];

  return (
    <AgGridContainer
      rowData={rowData}
      columnDefs={columnDefs}
      additionalActions={additionalActions}
      tableName={AgGridTables.BUSINESS_LABELS}
    />
  );
};

export const BusinessLabels = () => (
  <Row flexGrow full>
    <Column margin={2} gridGap={2} full>
      <Paper square>
        <BusinessLabelTable />
      </Paper>
    </Column>
  </Row>
);
